import React from 'react'
import Main from '../../Layout/Main'
import Tittle from '../../Components/accommodation/Tittle'
import Testimonail from '../../Components/accommodation/Testimonail'
import Subscribe from '../../Components/accommodation/Subscribe'

const Accommodation = () => {
  return (
    <Main>
        <Tittle/>
        <Testimonail/>
        <Subscribe/>
    </Main>
  )
}

export default Accommodation